import { JobQualifications } from "./jobQualifications";

import {
    JobActions,
    JobCandidatesFunnel,
    JobEngagementFunnel,
    JobOverview,
    JobStats,
    Order,
    Team,
} from "./";

export class JobDetails {
    details: JobOverview;
    order: Order;
    team: Team;
    jobQualifications: JobQualifications;
    jobConcurrencyToken: string;
    actions: JobActions;

    // deferred data
    jobCandidatesFunnel?: JobCandidatesFunnel;
    jobEngagementFunnel?: JobEngagementFunnel;
    jobStats?: JobStats;
}
